let googleMapsPromise: Promise<typeof google> | undefined;

export function loadGoogleMaps(apiKey: string): Promise<typeof google> {
  if (window.google?.maps) return Promise.resolve(window.google);
  googleMapsPromise ??= new Promise((resolve, reject) => {
    const callbackName = '__poolAppyGoogleMapsReady';
    const target = window as Window & { __poolAppyGoogleMapsReady?: () => void };
    target.__poolAppyGoogleMapsReady = () => {
      if (window.google?.maps) resolve(window.google);
      else reject(new Error('Google Maps did not initialise.'));
      delete target.__poolAppyGoogleMapsReady;
    };
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=${callbackName}&v=weekly`;
    script.async = true;
    script.onerror = () => reject(new Error('Google Maps failed to load.'));
    document.head.appendChild(script);
  });
  return googleMapsPromise;
}
